import { render } from "./GoalKRCreationActivity.vue?vue&type=template&id=ee074fb0"
import script from "./GoalKRCreationActivity.vue?vue&type=script&lang=js"
export * from "./GoalKRCreationActivity.vue?vue&type=script&lang=js"
script.render = render

export default script